import React, { useCallback, useContext, useEffect, useState } from "react";
import { ImpressionContext } from "../components/managers";
import useIntersection from "./useIntersection";
import useCachedViewTrack from "./useCachedViewTrack";

const useImpression = ({
	id,
	cacheKey,
	event,
	properties,
	target,
	callback = null,
	isActive = true,
} = {}) => {
	const {
		activeEntities,
		isEntityActive,
		createEntityTimelineRecord,
		addEntityCallback,
		removeEntityCallback,
	} = useContext(ImpressionContext);

	const [shouldTrackImpression, setShouldTrackImpression] = useState(false);

	const { hasBeenTracked } = useCachedViewTrack({
		id,
		key: cacheKey,
		event,
		properties,
		canTrack: shouldTrackImpression,
	});

	const handleCallback = useCallback(() => {
		setShouldTrackImpression(true);
		if (typeof callback !== "function") return;
		callback();
	}, [callback]);

	useEffect(() => {
		if (hasBeenTracked) return;
		addEntityCallback(id, handleCallback);
		return () => {
			removeEntityCallback(id);
		};
	}, [
		id,
		addEntityCallback,
		removeEntityCallback,
		handleCallback,
		hasBeenTracked,
	]);

	useIntersection({ target, disable: !isActive || hasBeenTracked });

	return {
		activeEntities,
		isEntityActive,
		createEntityTimelineRecord,
		addEntityCallback,
		removeEntityCallback,
	};
};

export default useImpression;
